import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// CLIENT PO AMENDMENT APIs
// Legacy route: /Accounts/AddNewClientPOAmend
// ==============================================

// 1. Get Cost Centers eligible for PO amendment (GET)
export const getAmendCostCenters = async () => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetAmendCostCenters`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get Amend Cost Centers API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get PO Numbers for a Cost Center (GET)
export const getPOByCC = async (ccCode) => {
    try {
        const queryParams = new URLSearchParams({ CCcode: ccCode });
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetPobyCC?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get PO By CC API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Cost Center details for the "View CC Details" panel (GET)
export const getCCDetailsByCcCode = async (ccCode) => {
    try {
        const queryParams = new URLSearchParams({ CcCode: ccCode });
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetCCDetailsbyCcCode?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get CC Details By CC Code API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Save the Amend Client PO (POST)
export const saveAmendPO = async (params) => {
    try {
        const payload = {
            oldPONO: params.oldPONO,
            amendpocompletiondate: params.amendpocompletiondate,
            Amendpono: params.amendpono,
            Amendpovalue: params.amendpovalue,
            Amendtotalvalue: params.amendtotalvalue,
            Amendegst: params.amendegst,
            Action: 'New',
            RoleId: params.roleId,
            Createdby: params.createdBy,
        };

        const response = await axios.post(
            `${API_BASE_URL}/Accounts/SaveAmendPO`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Save Amend PO API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
